import React from "react";
import { Link } from "react-router-dom";

export const IdentityResetHero = () => {
  return (
    <>
      {/* SECTION 1: Hero */}
      <section className="bg-[#FAF6F0] w-full">
        <p className="text-center text-xs md:text-sm font-bold text-[#9E1B50] uppercase tracking-wide py-4 px-4">
          Save when you bundle Identity Reset plus the workbook.
        </p>
        <div className="relative w-full aspect-[16/10] md:aspect-[21/9] bg-neutral-300 overflow-hidden">
          <img
            src="https://vibe.filesafe.space/1787853701390843161/attachments/f5132870-2eff-4cb6-857e-02f5311e029c.jpg"
            alt="Ieshia Danielle teaching the Identity Reset workshop"
            className="absolute inset-0 w-full h-full object-cover"
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
          <div className="absolute bottom-0 left-0 p-6 sm:p-10 md:p-16 max-w-2xl">
            <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.25em] text-white/70 block mb-3">
              WORKSHOP + INTERACTIVE EXPERIENCE
            </span>
            <h1 className="font-serif text-4xl sm:text-6xl md:text-7xl font-normal text-white leading-[0.95]">
              IDENTITY
              <br />
              <span className="italic">RESET.</span>
            </h1>
            <a
              href="https://store.iamieshiadanielle.com/product-details/product/6a9990d12ec6f6c3e6a0fe7f"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-block bg-white text-[#4A0E26] font-bold uppercase text-[11px] tracking-wider px-6 py-3 rounded-full hover:bg-[#FAF6F0] transition-all"
            >
              Add To Cart - $47 →
            </a>
          </div>
        </div>
      </section>

      {/* SECTION 2: Statement */}
      <section className="bg-white w-full py-6 md:py-16 border-b border-[#E8DEC8]">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-4xl mx-auto text-center space-y-3">
          <h2 className="font-serif sm:text-3xl md:text-4xl font-bold text-[#380C1E] leading-tight pl-0 pr-0 text-sm">
            You Have Been Everything For Everyone Else And Lost Yourself Along
            The Way.
          </h2>
          <p className="font-serif sm:text-3xl md:text-4xl font-bold text-[#9E1B50] text-sm">
            This Is Your Opportunity To Reset.
          </p>
        </div>
      </section>
    </>
  );
};
